import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { colors, radii, shadows, spacing } from '~/ui/tokens';

interface CardProps {
  children: React.ReactNode;
  elevation?: keyof typeof shadows;
  style?: StyleProp<ViewStyle>;
}

export function Card({ children, elevation = 'card', style }: CardProps) {
  return <View style={[styles.base, shadows[elevation], style]}>{children}</View>;
}

const styles = StyleSheet.create({
  base: {
    backgroundColor: colors.card,
    borderRadius: radii.lg,
    padding: spacing(2),
  },
});
